import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';

import { cn } from '@/lib/utils';

/**
 * The Purchases sub-navigation: Purchase Orders (PUR-01), Goods Received
 * Notes (PUR-02), Purchase Invoices (PUR-03), Purchase Returns (PUR-04 — the
 * debit note, and the last of the five to be built) and Import Orders
 * (PUR-06). Each is its own screen on its own route, owner ruling R3.
 */
const TABS = [
  // Purchase Invoices lead, and the section opens on them (owner ruling 27 Sep
  // 2026): the bills list lives at the bare /purchases path, orders at their own.
  { to: '/purchases', end: true, key: 'po.tabBills' },
  { to: '/purchases/orders', end: false, key: 'po.tabOrders' },
  { to: '/purchases/receipts', end: false, key: 'po.tabReceipts' },
  { to: '/purchases/returns', end: false, key: 'po.tabReturns' },
  { to: '/purchases/imports', end: false, key: 'po.tabImports' },
  // Wave 5A — the reorder builder: suggestions → a draft order (PUR-01).
  { to: '/purchases/reorder', end: false, key: 'po.tabReorder' },
] as const;

export function PurchasesTabs() {
  const { t } = useTranslation();
  return (
    <nav className="flex flex-wrap gap-1 border-b pb-px" aria-label={t('shell.navPurchases')}>
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end}
          className={({ isActive }) =>
            cn(
              'rounded-t-md px-3 py-2 text-sm font-medium text-muted-foreground hover:text-foreground',
              isActive && 'border-b-2 border-primary text-foreground',
            )
          }
        >
          {t(tab.key)}
        </NavLink>
      ))}
    </nav>
  );
}
